module.exports = __webpack_public_path__ + "static/inst-icon-f3bd500d50d6038a6f966159acc4c648.jpg";